import React, {useEffect, useState} from "react";
import shopify from "../Assets/images/shopify.png"
import cart from "../Assets/images/cart.png"
import opencart from "../Assets/images/opencart.png"
import woocomerce from "../Assets/images/woocomerce.png"
import whm from "../Assets/images/whm.png"
import bgHero from "../Assets/images/sectionsix.png";

const SectionSix = () => {
    const [windowWidth, setWindowWidth] = useState(0);

    let resizeWindow = () => {
        setWindowWidth(window.screen.width);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return (
        <div
            style={{
                backgroundImage: `url(${bgHero})`,
                backgroundSize: windowWidth < 500 ? '45%' : '25%',  // Ensures the image covers the entire div
                backgroundPosition: 'right 60%', // Centers the image
                backgroundRepeat: 'no-repeat', // Prevents tiling

            }}
            className="w-full flex ">
        <div className='mx-auto  lg:w-maxWidth w-full flex flex-col gap-12 mt-10 lg:mt-36 mb-10 lg:p-0  p-4'>
            <div className='w-full flex items-center justify-center flex-col gap-4'>
                <h2 className="font-axiforma  font-light text-primary text-center leading-10 lg:leading-0 text-2xl lg:text-4xl  ">Go global on <b className="font-bold">social commerce</b></h2>
                <p className=" font-axiforma text-secondary text-lg">If you’re running a retail store without a POS machine. With the PayPro Business App you can easily generate and share instant payment links or QR codes of the invoice and accept card payments at point of sale, without disappointing your walk in customers</p>
            </div>

            <div className='w-full flex items-center justify-center flex-col pt-14 gap-4'>
                <h2 className="font-axiforma  font-light text-primary text-center leading-10 lg:leading-0 text-2xl lg:text-4xl  ">Payment Gateway <b className="font-bold">for your website</b></h2>
                <p className=" font-axiforma text-secondary text-lg">You can easily integrate your e-store with PayPro’s Internet Payment Gateway by requesting the API plugin for your website or mobile app with through the business app.</p>
            </div>
            <div className='w-full flex justify-between items-center'>
                <img className='w-1/6' src={shopify} alt={shopify} />
                <img className='w-1/6' src={cart} alt={cart} />
                <img className='w-1/6' src={woocomerce} alt={woocomerce} />
                <img className='w-1/6' src={opencart} alt={opencart} />
                <img className='w-1/6' src={whm} alt={whm} />
            </div>
        </div>
        </div>
    )
}

export default  SectionSix